import {t} from "@lingui/core/macro";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";

import {IsIndexedSearchEnabledForLocale} from "./is-indexed-search-enabled-for-locale.ts";

const TryThisButton = ({locale, isDefaultState, toggleFunc, tryNotSee}) => {
    if (!IsIndexedSearchEnabledForLocale(locale)) {
        return null;
    }

    const introString = t`Not seeing what you're looking for?`;
    let linkString = t`See our Google-powered results`;

    if (!isDefaultState) {
        linkString = t`Back to Khan Academy Search`;
    }
    if (tryNotSee) {
        linkString = t`Or, try our Google-powered results.`;
    }

    const link = (
        <Button
            kind="tertiary"
            size="small"
            style={{minWidth: 160}}
            onClick={toggleFunc}
        >
            {linkString}
        </Button>
    );

    const withIntro = (
        <span>
            {introString} {link}
        </span>
    );
    const withoutIntro = <span>{link}</span>;

    return (
        <View>{isDefaultState && !tryNotSee ? withIntro : withoutIntro}</View>
    );
};

export default TryThisButton;
